import { render, staticRenderFns } from "./domestic.vue?vue&type=template&id=3c3e8c20&scoped=true&"
import script from "./domestic.vue?vue&type=script&lang=js&"
export * from "./domestic.vue?vue&type=script&lang=js&"
import style0 from "./domestic.vue?vue&type=style&index=0&id=3c3e8c20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e8c20",
  null
  
)

export default component.exports